// extracted by mini-css-extract-plugin
export var dateLabel = "_42-0";
export var dateLabelError = "_42-1";
export var fullWidth = "_42-2";
export var smaller = "_42-3";